import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { DividerComponent } from '../../../../common/divider/divider.component';
import { GroupComponent } from '../../../../common/group/group.component';
import type { Variants } from '../../../../utils/variant/variant';
import { ComponentVariant } from '../../../../utils/variant/variant';

type InnerPadding = 'default' | 'medium' | 'small';

@Component({
  selector: 'rt-dialog-footer',
  templateUrl: './dialog-footer.component.html',
  styleUrls: ['./dialog-footer.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.inner-padding-medium]': 'innerPadding === "medium"',
    '[class.inner-padding-small]': 'innerPadding === "small"',
    '[class.no-background]': '!hasBackground',
    '[class]': 'variant',
  },
  imports: [DividerComponent, GroupComponent],
})
export class DialogFooterComponent {
  public static readonly VARIANTS: Variants = [
    'default',
    ['white', 'background', 'neutral-default', 'default', 'no-padding'],
  ];
  @ComponentVariant(DialogFooterComponent.VARIANTS)
  @Input()
  public variant: string;
  @Input() public hasDivider: boolean = true;
  @Input() public hasOptionalActions: boolean = false;
  @Input() public hasBackground: boolean = true;
  @Input() public innerPadding: InnerPadding = 'default';
}
